import { FC } from "react";
import Day from "./Day";

export type MonthProps = {
  days: Date[];
};

const Month: FC<MonthProps> = ({ days }) => {
  return (
    <>
      {days.map((day, idx) => {
        return <Day key={idx} day={day} />;
      })}
    </>
  );
};

export default Month;
